import "./AddressHeader.css";
import { MapPinned } from "lucide-react";

export default function AddressHeader() {

    return (

        <header className="address-header">

            <div className="address-header-icon">

                <MapPinned size={34} />

            </div>

            <div className="address-header-content">

                <h2>

                    انتخاب آدرس

                </h2>

                <p>

                    آدرس تحویل سفارش خود را انتخاب کنید یا یک آدرس جدید ثبت نمایید.

                </p>

            </div>

        </header>

    );

}